export const education = [
    {
        time: "2019-2022",
        grade: "9.0 GPA",
        Degree: "Masters of Computer Applications",
        College:"IMCC-Pune",
        Description:"Most of the time spent attending online lectures due to the COVID-19 lockdown. However, this situation encouraged me to utilize my free time for self-learning and exploring additional languages. I also took the opportunity to gain practical experience through online internships during this period."
      },
      {
        time: "2016-2019",
        grade: "First class with distinction",
        Degree: "Bachelors of Computer Applications",
        College:"MIT-Pune",
        Description:"The BCA (Bachelor of Computer Applications) course provided me with a strong foundation in computer science and programming,allowing me to learn and explore my interest in coding and solving problems, giving me the ability to develop a deep understanding of different programming languages such as C, C++ and Java and tackle difficult challenges in the technology field."
      },
]

export const hobbies = [
  {
      title: "Adventure Activities",
      icon: "pyramid"
    },
    {
      title: "Traveling",
      icon: "trip"
    },
    {
      title: "Reading",
      icon: "book"
    },
    {
      title: "Painting",
      icon: "palette"
    },
    {
      title: "Watching Anime/Series/Movies",
      icon: "camera-movie"
    },
]